import { defineMessages } from "react-intl";

const BANK_STATEMENTS_MESSAGES = defineMessages({
  defaultDetailsTextBankName: {
    id: "funding-application: air bank statements required text details default bank name",
    defaultMessage: "Bank",
    description: "In the case where we do not have a bank name e.g. 'Chase', refer to as 'Bank'",
  },
});

const REVENUE_SOURCE_MESSAGES = defineMessages({});

const RECONNECT_CONNECTION_MESSAGES = defineMessages({
  reasonPreviousPlatformDecommissionedOption: {
    id: "funding-application: reason air reconnect platform decommissioned option",
    defaultMessage: "My previous {platformType} has been decommissioned",
    description:
      "Reason option for when the previous platform has been decommissioned. Platform type is the specific type of platform e.g. 'eCommerce' or 'Marketing.",
  },
});

export const MESSAGES = defineMessages({
  airReviewPageHeading: {
    id: "funding-application: air review title",
    defaultMessage: "Requests for additional information",
  },
  airReviewPageOnHoldBannerTitle: {
    id: "funding-application: air review app on hold banner title",
    defaultMessage: "Your application is on hold",
  },
  airReviewPageOnHoldBannerSubheading: {
    id: "funding-application: air review app on hold banner subheading",
    defaultMessage: "Please complete the requests below to progress your application.",
  },
  ...BANK_STATEMENTS_MESSAGES,
  ...REVENUE_SOURCE_MESSAGES,
  ...RECONNECT_CONNECTION_MESSAGES,
});
